import { useNavigate } from 'react-router-dom';
import TabBar from '../../components/TabBar';
import ObservationsTab from './ObservationsTab';

export default function AdminObservationsPage() {
  const navigate = useNavigate();
  return (
    <div className="screen">
      <div className="obsbar">
        <button className="obsbar-back" onClick={() => navigate('/')}>← Back</button>
        <div className="obsbar-title">Observations</div>
      </div>
      <div className="scroll">
        <div className="pad"><ObservationsTab /></div>
      </div>
      <TabBar current="observations" />
    </div>
  );
}
